import { BaseService } from "../BaseService";
import { SiteConfigBaseService } from "./SiteConfigBaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { SiteConfigModel } from "../../models/api/SiteConfigModel";
import { SiteConfigFindResultModel } from "../../models/api/SiteConfigFindResultModel";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class SiteConfigService extends SiteConfigBaseService {

    constructor(private h: HttpClient, private r: Router, private a: AuthService) {
        super(h, r, a);
    };

}
